import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';


function FamilySettingsEditClanAdd() {

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


const [clanName, setClanName] = useState("");
  
  const [isSubmitting, setIsSubmitting] = useState(false);

const handleClanSubmit = async () => {
    if (!clanName.trim()) {
      toast.error("Please enter your clan name.");
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      const res = await axios.post(
        `${API_URL}/family-settings-edit-clan-add-api`,
        { clan_name: clanName },
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error("Failed to register clan.");
      }
    } catch (error) {
      console.error("Clan submission error:", error);
      toast.error("Something went wrong.");
    } finally {
      setIsSubmitting(false); //always reset
    }
  };


  return (

    <div className='scrollPageContainer theme-light' >
    <div className='main-wrapper' >

            {/*start of header*/}
         {isSidebarVisible && <Sidebar />}
         <Header toggleSidebar={toggleSidebar} />
         {/*end of header */}
         {/*start of sidebar*/}
         <Sidebar show={showSidebar} toggle={toggleSidebar} />
         {/*End of sidebar*/}
         {/* start of footerbar */}
         <Footerbar toggleSidebar={toggleSidebar} />
         {/* end of footerbar */}
        <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">

            <div className='row'>

            <div className='col-md-12'>

                    <div className='card'>
                  <div className='card-body'>

                    <p style={{ fontWeight: '900'}}><center>You can register your new clan here</center></p>


              <input
                    type="text"
                    className="form-control mt-3"
                    placeholder="Enter Clan Name"
                    value={clanName}
                    onChange={(e) => setClanName(e.target.value)}
                    
                    onFocus={(e) => e.target.scrollIntoView({ behavior: 'smooth', block: 'center' })}
                  />

<div className="d-flex justify-content-between align-items-center mt-4">
  <Link onClick={() => navigate(-1)} className="btn btn-secondary">Back</Link>

  <button onClick={handleClanSubmit} 
   type="button"
    className="btn btn-primary"
    disabled={isSubmitting}
  >
    {isSubmitting ? "Updating..." : "Update"}
  </button>
</div>



                    </div>
                    </div>

            </div>

             
            </div>

          </div>
        </div>
      </div>
      </div>
  );
}

export default FamilySettingsEditClanAdd;
